import Panel from "../Panel/PanelShimmer";

export const Advocacy = () => {
  const onClick = () => {
    window.location.href = "https://worldvisionadvocacy.org/";
  }

  return (
    <Panel classList="more-wv__advocacy" shimmerProps={{height: "400px", classList: 'more-wv__advocacy', testId: 'community-progress'}}
    showShimmer={false}>
      <h3 className="eta">Use your voice, now</h3>
      <img src="https://wvusstatic.com/mywv/msc/feed/advocacy-photo.jpg" alt="advocacy" />
      <p>Tell congress what matters. Saying nothing does nothing. Encourage your members of congress to value every single child and their quality of life.</p>
      <button type="button" className="btn btn-small btn-ghost-orange" onClick={onClick}>
        Join Us Now
      </button>
    </Panel>
  );
}

export default Advocacy;